import { render, staticRenderFns } from "./PostingModalV2.vue?vue&type=template&id=4cf98c85"
import script from "./PostingModalV2.vue?vue&type=script&lang=ts"
export * from "./PostingModalV2.vue?vue&type=script&lang=ts"
import style0 from "./PostingModalV2.vue?vue&type=style&index=0&id=4cf98c85&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf98c85')) {
      api.createRecord('4cf98c85', component.options)
    } else {
      api.reload('4cf98c85', component.options)
    }
    module.hot.accept("./PostingModalV2.vue?vue&type=template&id=4cf98c85", function () {
      api.rerender('4cf98c85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/postings/PostingModalV2.vue"
export default component.exports